import TasksLogsInner from "Areas/SharedFeatures/tasksLogs/tasksLogs.inner";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getActiveDocumentId, getLogLevels, getTasksLogAllData, getTasksLogDataForDocumentInProgress } from "../redux/selectors";
const mapStateToProps = (state, ownProps) => ({
    data: getTasksLogAllData(state),
    logLevels: getLogLevels(state),
    documentId: getActiveDocumentId(state),
    inProgress: getTasksLogDataForDocumentInProgress(state) && !ownProps.parentInProgress
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (documentId) => dispatch(actionCreators.getTasksLogsDataForDocument(documentId)),
    onClear: (documentId) => {
        dispatch(actionCreators.setTasksLogsSocketData([], documentId));
        dispatch(actionCreators.setTasksLogsData([], documentId));
    },
    onSetLogLevels: (logLevels, documentId) => dispatch(actionCreators.setLogLevels(logLevels, documentId))
});
export default connect(mapStateToProps, mapDispatchToProps)(TasksLogsInner);
